// Ported from advisor-3.0/src/sessionStorage.js

export const SESSION_STORAGE_ACCOUNT_KEY = 'ACCOUNT_OBJECT';
export const SESSION_STORAGE_ESIGN_AUTH_KEY = 'ESIGN_AUTH';
export const SESSION_STORAGE_IS_AUTH_KEY = 'IS_AUTH';
export const SESSION_STORAGE_IS_SIGN_WITHOUT_AUTH = 'IS_SIGN_WITHOUT_AUTH';
export const SESSION_STORAGE_ROUTING_KEY = 'ROUTING';
export const SESSION_STORAGE_AUTH_TOKEN = 'AUTH_TOKEN';
export const ADVISOR_OBJECT_KEY = 'ADVISOR_OBJECT';

interface ExpiringEnvelope<T> {
  value: T;
  expiration: string | Date;
}

const PAGES_TO_PREVENT_REDIRECT_ON_EXPIRE = ['status', 'landing', 'retrieveprogress'];

function shouldRedirect(): boolean {
  let currentURL = window.location.href.split('/');
  currentURL = currentURL.map((url) => url.split('?')[0]);
  return !currentURL.some((segment) =>
    PAGES_TO_PREVENT_REDIRECT_ON_EXPIRE.includes(segment.toLowerCase()),
  );
}

export function setSessionStorageItemWithExpiration<T>(
  key: string,
  value: T,
  timeoutInMinutes: number,
): void {
  const now = new Date();
  const expireTime = new Date(now.getTime() + timeoutInMinutes * 60000);
  const storeItem: ExpiringEnvelope<T> = { value, expiration: expireTime };
  try {
    sessionStorage.setItem(key, JSON.stringify(storeItem));
  } catch (e) {
    // QuotaExceededError
    console.warn('Session storage write failed', e);
  }
}

export function setSessionStorageItem<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.warn('Session storage write failed', e);
  }
}

export function getSessionStorageItem<T = unknown>(key: string): T | null {
  const item = sessionStorage.getItem(key);
  if (!item) return null;

  let itemJson: ExpiringEnvelope<T> | T | null;
  try {
    itemJson = JSON.parse(item) as ExpiringEnvelope<T> | T | null;
  } catch {
    return null;
  }

  if (itemJson == null) return null;

  if (typeof itemJson === 'object' && 'expiration' in (itemJson as object)) {
    const envelope = itemJson as ExpiringEnvelope<T>;
    const currentTime = new Date();
    const expireTime = new Date(envelope.expiration);

    if (currentTime > expireTime) {
      if (shouldRedirect()) {
        sessionStorage.clear();
        window.location.href = '/';
        return null;
      }
    } else {
      // extend timeline on access
      setSessionStorageItemWithExpiration(key, envelope.value, 60);
    }
    return envelope.value;
  }

  return itemJson as T;
}
